export type BreadcrumbItem = 'Use a survey template' | 'Send a survey' | 'My surveys' | 'Contact us' | 'Surveys' | 'Suppliers';
export const BreadcrumbItem = {
  SurveyTemplates: 'Use a survey template' as BreadcrumbItem,
  SendASurvey: 'Send a survey' as BreadcrumbItem,
  MySurveys: 'My surveys' as BreadcrumbItem,
  ContactUs: 'Contact us' as BreadcrumbItem,
  Surveys: 'Surveys' as BreadcrumbItem,
  Suppliers: 'Suppliers' as BreadcrumbItem
};
